import { useCallback, useState } from 'react';

export type ToggleType = ReturnType<typeof useToggle>;

/**
 * A hook for toggling a boolean value.
 */
export function useToggle(initialState = false): [boolean, (value?: boolean) => void] {
    const [state, setState] = useState(initialState);

    const toggle = useCallback((value?: boolean) => {
        if (typeof value === 'boolean') {
            setState(value);
        } else {
            setState((state) => !state);
        }
    }, []);

    return [state, toggle];
}
